<template>
  <div class="container">
    <div class="row">
      <div class="col-xs-12">
        <h3 class="title">Serviços para Empresas</h3>
        <hr class="h-rule-yellow">
        <hr class="h-rule-side-yellow">
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 margin-b10">
        <h3 class="bold upper">Planos Pré-pagos</h3>
        <p>Conheça as vantagens que cada plano possui e escolha o que melhor se encaixa na necessidade do seu negócio:</p>
      </div>
    </div>

    <b2b type="adhesion"></b2b>

    <div class="row">
      <div class="col-xs-12">
        <router-link to="/servicos-b2b" class="btn btn-back">
          <i class="icon-circle-left align-icon-left"></i>
          Voltar
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
  import b2b from './plans/b2b.vue'
  export default {
    components: {
      b2b
    }
  }
</script>
<style scoped lang="scss">
  p {
    line-height: 15px;
  }
  .col-md-3 {
    width: 27.7%;
  }
  .icon-plans-table {
    color: #000;
    font-size: 4.5em;
  }
  .payment-list li {
    list-style-type: inherit;
    text-align: left;
    margin: 0 0 0 28%;
  }
  .first-col {
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    -ms-border-radius: 10px;
    -o-border-radius: 10px;
    border-radius: 10px;
    background: #ebebeb;
    font-weight: bold;
    min-height: 450px;
    padding: 0;
  }
  .first-col p {
    line-height: 20px;
    margin-top: 10px;
  }
  .first-col .first-line {
    min-height: 130px;
    padding: 38px 10px 34px;
    text-align: center;
  }
  .first-col .second-line {
    background: #dfdfdf;
    min-height: 100px;
    padding: 30px 10px;
  }
  .first-col .third-line {
    min-height: 80px;
    padding: 20px 10px;
  }
  .first-col .fourty-line {
    background: #dfdfdf;
    min-height: 95px;
    padding: 20px;
  }
  .first-col .fifty-line {
    -webkit-border-radius: 0px 0px 10px 10px;
    -moz-border-radius: 0px 0px 10px 10px;
    -ms-border-radius: 0px 0px 10px 10px;
    -o-border-radius: 0px 0px 10px 10px;
    border-radius: 0px 0px 10px 10px;
    min-height: 86px;
  }
  .first-col .text-question {
    font-weight: bold;
    text-align: center;
  }
  .second-col {
    -webkit-border-radius: 10px;
    border-radius: 10px;
    border: 2px solid #613A7D;
    color: #463168;
    min-height: 450px;
    padding: 10px 20px;
    text-align: center;
  }
  .second-col .second-line {
    background: rgba(0,0,0,0.05);
    font-size: 0.9em;
    margin: 0 -20px;
    padding: 20px 10px;
  }
  .second-col .third-line {
    font-weight: bold;
    min-height: 80px;
    padding: 25px 10px;
  }
  .second-col .fourty-line {
    background: rgba(0,0,0,0.05);
    margin: 0 -20px;
    min-height: 95px;
    padding: 20px 10px;
  }
  .third-col {
    -webkit-border-radius: 10px;
    border-radius: 10px;
    background: #613A7D;
    color: white;
    min-height: 450px;
    padding: 10px 20px;
    text-align: center;
  }
  .third-col .second-line {
    background: rgba(0,0,0,0.05);
    font-size: 0.9em;
    margin: 0 -20px;
    min-height: 102px;
    padding: 20px 10px;
  }
  .third-col .third-line {
    font-weight: bold;
    min-height: 80px;
    padding: 25px 10px;
  }
  .third-col .fourty-line {
    background: rgba(0,0,0,0.05);
    margin: 0 -20px;
    min-height: 95px;
    padding: 25px 10px;
  }
  .fourth-col {
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    -ms-border-radius: 10px;
    -o-border-radius: 10px;
    border-radius: 10px;
    background: #61a60e;
    color: white;
    min-height: 450px;
    padding: 10px 20px;
    text-align: center;
  }
  .fourth-col .second-line {
    background: rgba(0,0,0,0.05);
    font-size: 0.9em;
    margin: 0 -20px;
    min-height: 102px;
    padding: 20px 10px;
  }
  .fourth-col .third-line {
    font-weight: bold;
    min-height: 80px;
    padding: 25px 10px;
  }
  .fourth-col .fourty-line {
    background: rgba(0,0,0,0.05);
    margin: 0 -20px;
    min-height: 95px;
    padding: 35px 10px 0px;
    ul {
      padding-bottom: 20px;
    }
  }
  .second-col .title {
    margin: 5px 0 15px;
    padding: 0 50px;
  }
  .third-col .title,
  .fourth-col .title {
    color: white;
    margin: 5px 0 15px;
    padding: 0 50px;
  }
  .second-col p,
  .third-col p,
  .fourth-col p {
    margin: 0;
  }
  .second-col .first-line {
    min-height: 128px;
  }
  .third-col .first-line,
  .fourth-col .first-line {
    min-height: 130px;
  }
  .row-button {
    height: 87px;
    margin: 0 -20px -10px;
    padding: 22px 0 0;
    .btn-primary {
      background: transparent;
      border: 2px solid white;
      padding: 10px 36px;
      box-shadow: none !important;
      -webkit-box-shadow: none !important;
      -moz-box-shadow: none !important;
    }
    .btn-primary:hover {
      background: white;
      color: #503066;
    }
    .btn-primary:active {
      background: rgba(0,0,0,0.2);
      border: 2px solid white;
      color: white;
    }
    .btn-default {
      background: transparent;
      border: 2px solid #613A7D;
      color: #613A7D;
      padding: 10px 36px;
      box-shadow: none !important;
      -webkit-box-shadow: none !important;
      -moz-box-shadow: none !important;
    }
    .btn-default:hover {
      background: #503066;
      border: 2px solid #503066;
      color: white;
    }
    .btn-default:active {
      background: #341045;
    }
  }
  .recharge-info {
    margin-top: 5px;
  }
  @media screen and (max-width: 991px) {
    .first-col {
      display: none;
    }
    .second-col,
    .third-col {
      margin-bottom: 20px;
    }
    .col-md-3 {
      width: 100%;
    }
  }
  @media screen and (max-width: 500px) {
    p {
      padding: 0 !important;
    }
    .btn-primary {
      padding: 10px 30px;
    }
    .second-col,
    .third-col,
    .fourth-col,
    .second-col .first-line,
    .third-col .first-line,
    .fourth-col .first-line,
    .second-col .second-line,
    .third-col .second-line,
    .fourth-col .second-line {
      font-size: 1em;
      min-height: 0;
    }
    .second-col .title,
    .third-col .title,
    .fourth-col .title {
      padding: 0 15px;
    }
  }
  .box-recharge {
    float: left;
    height: 150px;
    margin: 0 30px 25px 0;
    width: calc(20.25% - 30px);
  }
  .box-recharge-last {
    float: left;
    height: 150px;
    margin: 0 0 25px 0;
    width: 19%;
  }
  .recharge-red {
    -webkit-border-radius: 10px;
    background: #E74213;
    border-radius: 10px;
    color: white;
    width: 100%
  }
  .recharge-label-red {
    -webkit-border-radius: 10px 10px 0 0;
    background: white;
    border: 2px solid #E74213;
    border-radius: 10px 10px 0 0;
    color: #E74213;
    font-size: 3em;
    font-weight: bold;
    padding: 5px 20px;
    text-align: center;
    width: 100%;
  }
  .recharge-value-red {
    -webkit-border-radius: 10px 0 10px 0;
    background: #E74213;
    border-radius: 10px 0 10px 0;
    float: left;
    padding: 5px;
  }
  .recharge-yellow {
    -webkit-border-radius: 10px;
    background: #EDA801;
    border-radius: 10px;
    color: white;
    width: 100%
  }
  .recharge-label-yellow {
    -webkit-border-radius: 10px 10px 0 0;
    background: white;
    border: 2px solid #EDA801;
    border-radius: 10px 10px 0 0;
    color: #EDA801;
    font-size: 3em;
    font-weight: bold;
    padding: 5px 20px;
    text-align: center;
    width: 100%;
  }
  .recharge-value-yellow {
    -webkit-border-radius: 10px 0 10px 0;
    background: #EDA801;
    border-radius: 10px 0 10px 0;
    float: left;
    padding: 5px;
  }

  .recharge-green {
    -webkit-border-radius: 10px;
    background: #569109;
    border-radius: 10px;
    color: white;
    width: 100%
  }
  .recharge-label-green {
    -webkit-border-radius: 10px 10px 0 0;
    background: white;
    border: 2px solid #569109;
    border-radius: 10px 10px 0 0;
    color: #569109;
    font-size: 3em;
    font-weight: bold;
    padding: 5px 20px;
    text-align: center;
    width: 100%;
  }
  .recharge-value-green {
    -webkit-border-radius: 10px 0 10px 0;
    background: #569109;
    border-radius: 10px 0 10px 0;
    float: left;
    padding: 5px;
  }
  .recharge-blue {
    -webkit-border-radius: 10px;
    background: #0074c8;
    border-radius: 10px;
    color: white;
    width: 100%
  }
  .recharge-label-blue {
    -webkit-border-radius: 10px 10px 0 0;
    background: white;
    border: 2px solid #0074c8;
    border-radius: 10px 10px 0 0;
    color: #0074c8;
    font-size: 3em;
    font-weight: bold;
    padding: 5px 20px;
    text-align: center;
    width: 100%;
  }
  .recharge-value-blue {
    -webkit-border-radius: 10px 0 10px 0;
    background: #0074c8;
    border-radius: 10px 0 10px 0;
    float: left;
    padding: 5px;
  }
  .recharge-purple {
    -webkit-border-radius: 10px;
    background: #503066;
    border-radius: 10px;
    color: white;
    width: 100%
  }
  .recharge-label-purple {
    -webkit-border-radius: 10px 10px 0 0;
    background: white;
    border: 2px solid #503066;
    border-radius: 10px 10px 0 0;
    color: #503066;
    font-size: 3em;
    font-weight: bold;
    padding: 5px 20px;
    text-align: center;
    width: 100%;
  }
  .recharge-value-purple {
    -webkit-border-radius: 10px 0 10px 0;
    background: #503066;
    border-radius: 10px 0 10px 0;
    float: left;
    padding: 5px;
  }
  .recharge-tax-label {
    color: white;
    padding: 10px 5px;
    text-align: center;
    width: 100%
  }
  @media screen and (max-width: 500px) {
    .recharge-label-red,
    .recharge-label-yellow,
    .recharge-label-green,
    .recharge-label-blue,
    .recharge-label-purple {
      font-size: 2.0em;
      padding: 20px 20px;
    }
    .box-recharge,
    .box-recharge-last {
      float: left;
      font-size: 0.8em;
      margin: 0 10px;
      width: calc(50% - 20px);
    }
  }
  @media screen and (max-width: 991px) {
    .first-col-box {
      display: none;
    }
    .recharge-info {
      margin-bottom: 20px;
    }
  }

  @media screen and (min-width: 501px) and (max-width: 990px) {
    .second-col,
    .third-col,
    .fourth-col,
    .second-col .first-line,
    .third-col .first-line,
    .fourth-col .first-line,
    .second-col .second-line,
    .third-col .second-line,
    .fourth-col .second-line {
      font-size: 1em;
      min-height: 0;
    }
    .box-recharge,
    .box-recharge-last {
      float: left;
      margin: 0 15px 20px;
      width: calc(33% - 30px);
    }
    .recharge-label-red,
    .recharge-label-yellow,
    .recharge-label-green,
    .recharge-label-blue,
    .recharge-label-purple {
      font-size: 2.1em;
      padding: 5px 25px;
    }
    .recharge-tax-label {
      font-size: 0.95em;
    }
  }
  @media screen and (min-width: 991px) and (max-width: 1199px) {
    .btn-primary {
      padding: 10px 30px;
    }
    .first-col .first-line {
      min-height: 170px;
    }
    .second-col .first-line {
      min-height: 146px;
    }
    .third-col .first-line,
    .fourth-col .first-line {
      min-height: 148px;
    }
    .first-col .second-line,
    .second-col .second-line,
    .third-col .second-line,
    .fourth-col .second-line {
      min-height: 115px;
    }
    .first-col .third-line,
    .second-col .third-line,
    .third-col .third-line,
    .fourth-col .third-line {
      min-height: 100px;
    }
    .second-col .third-line,
    .third-col .third-line {
      padding: 35px 10px;
    }
    .fourth-col .third-line {
      padding: 32px 10px;
    }
    .second-col .title,
    .third-col .title,
    .fourth-col .title {
      padding: 0 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// services-b2b-prepay.vue?aad6c988